import { delayedCall, dispatcher, ingenuity, killDelayedCall, Linear } from "@quest/base-core";
import { FreeGameViewBehavior, RetriggerController, RetriggerView, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";



export class FreeGameRetriggerController extends RetriggerController {

    constructor(view: RetriggerView, freegameview: FreeGameViewBehavior) {
        super(view, freegameview);
        this.ANIMATION_RETRIGGER_BASE = "basegame_idle_desktop";
        this.ANIMATION_RETRIGGER_TEXT = "freespin_intro_in";

        this.ANIMATION_RETRIGGER_OUT_BASE = "freespin_intro_out";
        this.ANIMATION_RETRIGGER_OUT_TEXT = "basegame_idle_desktop";

        this.ANIMATION_RETRIGGER_BASE_PORTRAIT = "basegame_idle_portrait";
        this.ANIMATION_RETRIGGER_TEXT_PORTRAIT = "freespin_intro_in";
        this.ANIMATION_RETRIGGER_OUT_BASE_PORTRAIT = "freespin_intro_out";
        this.ANIMATION_RETRIGGER_OUT_TEXT_PORTRAIT = "basegame_idle_portrait";
    }
    // Add to play desktop retrigger spine
    playRetriggerDesktopSpine() {
        dispatcher.fireEvent(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG);
        ingenuity.configData.showLogoBaseGameScreen = false;
        this.retriggerSpine.visible = true;
        this.retriggerSpine2.visible = true;
        this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_BASE, false);
        this.retriggerSpine2.playAnim(this.ANIMATION_RETRIGGER_TEXT, false);
        this.retriggerSpine2.onComplete.addOnce(() => {
            this.retriggerSpine2.onComplete.dispose();
            this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_OUT_TEXT, false);
            this.retriggerSpine2.playAnim("freespin_intro_loop", false);
            this.retriggerSpine2.onComplete.addOnce(() => {
                this.retriggerSpine2.onComplete.dispose();
                this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_OUT_TEXT, false);
                this.retriggerSpine2.playAnim(this.ANIMATION_RETRIGGER_OUT_BASE, false);
                this.retriggerSpine2.onComplete.addOnce(() => {
                    this.retriggerSpine2.visible = false;
                    this.retriggerSpine.visible = false;
                }, this);
            }, this);
        }, this);
    }

    // Add to play mobile portrait retrigger spine
    playRetriggerPortraitSpine() {
        this.retriggerPortraitSpine.visible = true;
        this.retriggerPortraitSpine2.visible = true;
        this.retriggerPortraitSpine.playAnim(this.ANIMATION_RETRIGGER_BASE_PORTRAIT, false);
        this.retriggerPortraitSpine2.playAnim(this.ANIMATION_RETRIGGER_TEXT_PORTRAIT, false);
        this.retriggerPortraitSpine2.onComplete.addOnce(() => {
            this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_BASE_PORTRAIT, false);
            this.retriggerSpine2.playAnim("freespin_intro_loop", false);
            this.retriggerSpine2.onComplete.addOnce(() => {
                this.retriggerPortraitSpine2.playAnim(this.ANIMATION_RETRIGGER_OUT_BASE_PORTRAIT, false);
                this.retriggerPortraitSpine.playAnim(this.ANIMATION_RETRIGGER_OUT_TEXT_PORTRAIT, false);
                this.retriggerPortraitSpine2.onComplete.addOnce(() => {
                    this.retriggerPortraitSpine2.visible = false;
                    this.retriggerPortraitSpine.visible = false;
                }, this);
            })

        }, this);
    }

    protected showRetriggerText(): void {
        this.retriggerText.setText(`+${(ingenuity.parserModel as GameParserModel).getRetriggerFreeSpins()}`);
        this.retriggerText.alpha = 0;
        this.retriggerText.visible = true;
        this.retriggerText.rotation = 0;
        const fadeInTween = ingenuity.currentGame.add.tween(this.retriggerText).to({ alpha: 1 }, 500, Linear.None, true, 700, 0, false);
        fadeInTween.onComplete.addOnce(() => {
            fadeInTween.stop();
            ingenuity.currentGame.tweens.remove(fadeInTween);
            this.hideRetriggerText();
            delayedCall(this.STR_COUNTER_ANIM, SlotConstantsBehavior.DURATION_2000, () => {
                killDelayedCall(this.STR_COUNTER_ANIM);
                this.showFreeGameCounterAnimation();
            }, this);
        }, this);
    }
    // To start retrigger presentation
    protected onRetriggerShow() {
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
        dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_IN_SOUND, { id: SoundConstant.FREGAME_BGLOOP, vol: 0.5, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
        this.showRetriggerText();
        this.showRetriggerSpine();
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.RETRIGGER_POP_UP_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
        delayedCall(this.STR_CHANGE_GRID, SlotConstantsBehavior.DURATION_200, () => {
            killDelayedCall(this.STR_CHANGE_GRID);
            this.updateStaticGrid();
        }, this);
    }
    protected hideRetriggerText() {
        dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG);
        ingenuity.configData.showLogoBaseGameScreen = true;
        const fadeOutTween = ingenuity.currentGame.add
            .tween(this.retriggerText)
            .to({ alpha: 0 }, 1000, Linear.None, true, 1500, 0, false);
        fadeOutTween.onComplete.addOnce(() => {
            fadeOutTween.stop();
            ingenuity.currentGame.tweens.remove(fadeOutTween);
        }, this);
    }
}